import { aircraftInformationSchema } from "../../forms/privateAviation/user/formSchema";
import AircraftInformation from "../../forms/privateAviation/user/steps/AircraftInformation";
import EditSectionPage from "./EditSectionPage";

const AircraftInformationEditPage = () => {
  return (
    <EditSectionPage
      title="Aircraft Information"
      schema={aircraftInformationSchema}
      step={2}
    >
      <AircraftInformation />
    </EditSectionPage>
  );
};

export default AircraftInformationEditPage;
